import { trackToDoCTA, useL10n } from '@uplift/hooks';
import { BaseDashboardActionItem, CheckYourInboxDialog } from '@uplift/ui-v2';
import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { EmailOutlined } from '@mui/icons-material';
import { ActionItemKeys, requestNewVerifyEmail } from '@uplift/api';
import { UserRole } from '@uplift/types';

export const VerifyAccountEmail: React.VFC = () => {
  const l10n = useL10n();
  const queryClient = useQueryClient();
  const [ isModalOpen, setIsModalOpen ] = useState(false);

  const handleClick = useCallback(async () => {
    await requestNewVerifyEmail();
    trackToDoCTA({
      toDoType: ActionItemKeys.PROVIDER_VERIFY_ACCOUNT_EMAIL,
      userType: UserRole.provider
    });

    setIsModalOpen(true);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    queryClient.invalidateQueries([ 'allActionItems' ]);
  };

  return (
    <>
      <BaseDashboardActionItem
        title={l10n.dashboard.actionItems.verifyEmail.title}
        color="warning"
        icon={<EmailOutlined />}
        action={{
          handleClick: handleClick,
          text: l10n.dashboard.actionItems.verifyEmail.actionText
        }}
      />
      <CheckYourInboxDialog open={isModalOpen} onClose={handleCloseModal}/>
    </>
  );
};
